<template lang="pug">
.target-other-user-detail-modal
  b-modal(v-model="_value" size="xl" @ok="ok" no-close-on-backdrop no-close-on-esc)
    template(#modal-header="{ cancel }")
      .option-target-other-user-list-modal-header
        .d-flex.justify-content-start.align-items-center
          .d-flex.justify-content-start
            span.menu-title 宛先一覧
      button(type="button" class="close" @click="cancel()") ×

    .option-target-other-user-list-modal-body
      TargetOtherUserDetailTable(
        v-model="_items"
        :fields="fields"
      )

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import TargetOtherUserDetailTable, { TargetOtherUserDetailTableField, TargetOtherUserDetailTableItem } from "@/pc/containers/sendDocuments/TargetOtherUserDetailTable.vue";

/**
 * ### 文書送付、確認・同意ユーザー一覧モーダル
 */
@Component({
  components: {
    TargetOtherUserDetailTable
  }
})
export default class TargetOtherUserDetailModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** テーブル行情報 */
  @Prop({ required: true })
  items!: Array<TargetOtherUserDetailTableItem>;

  /** テーブル列情報 */
  fields: Array<TargetOtherUserDetailTableField> = [];

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _items(): Array<TargetOtherUserDetailTableItem> {
    return this.items;
  }

  set _items(newValue: Array<TargetOtherUserDetailTableItem>) {
    this.$emit("update:items", newValue);
    return;
  }

  /**
   * ### vue lifesycle mounted
   */
  public mounted(): void {
    let fields: Array<TargetOtherUserDetailTableField> = this.createFields();
    this.fields = fields;

    return;
  }

  /**
   * ### 列名を作成する
   */
  public createFields(): Array<TargetOtherUserDetailTableField> {
    let fields: Array<TargetOtherUserDetailTableField> = [];

    fields.push({ key: "groupName", label: "グループ名（種類名）", sortable: false, sortDirection: "desc", class: "group-name" });
    fields.push({ key: "memberName", label: "メンバー名（所属）", sortable: false, sortDirection: "desc", class: "member-name" });
    fields.push({ key: "memberTel", label: "電話番号", sortable: false, sortDirection: "desc", class: "member-tel" });

    return fields;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }
}
</script>
